import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'baohansystem',
		component: () => import('@/modules/index/baohansystem/baohansystem')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/modules/index/login/login')
	},
	{
		path: '/Login-old',
		name: 'Login-old',
		component: () => import('@/modules/index/login/Login-old')
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('@/modules/index/register/register')
	},
	{
		path: '/apply-recordsystem',
		name: 'apply-recordsystem',
		component: () => import('@/modules/index/apply-recordsystem/apply-recordsystem')
	},
	{
		path: '/apply-recorddetails',
		name: 'apply-recorddetails',
		component: () => import('@/modules/index/apply-recorddetails/apply-recorddetails')
	},
	{
		path: '/guarantee/auth/login',
		name: 'accreditRegister',
		component: () => import('@/modules/index/accreditRegister')
	},
	{
		path: '/applySuccess',
		name: 'accreditRegister',
		component: () => import('@/components/apply-baohan/lanzhouindex.vue')
	},
	// 金控提交后, 相关界面路由
	{
		path: '/jinkongSuccess',
		name: 'jinkongSuccess',
		component: () => import('@/modules/jinkong/upLoadSuccess.vue')
	},
	// 中国农业银行提交后, 相关界面路由
	{
		path: '/nognyeSuccess',
		name: 'nognyeSuccess',
		component: () => import('@/modules/nongye/nognyeSuccess.vue')
	},

	// 人保提交后, 相关界面路由
	{
		path: '/applyPicc',
		name: 'applyPicc',
		component: () => import('@/modules/picc/index.vue'),
		redirect: "/applyPicc/success",
		children: [
			{
				path: 'success',
				name: 'applyPiccSuccess',
				component: () => import('@/modules/picc/applyPiccSuccess.vue')
			},
			{
				path: 'upLoad',
				name: 'applyPiccUpLoad',
				component: () => import('@/modules/picc/applyPiccUpLoad.vue')
			},
			{
				path: 'upLoadSuccess',
				name: 'upLoadSuccess',
				component: () => import('@/modules/picc/upLoadSuccess.vue')
			},
		]
	},
	{
		path: '/applyGsdb',
		name: 'applyGsdb',
		component: () => import('@/modules/picc/index.vue'),
		redirect: "/applyGsdb/gsdbResult",
		children: [
			{
				path: 'gsdbResult',
				name: 'gsdbResult',
				component: () => import('@/modules/gsdb/upLoadSuccess.vue')
			}
		]
	}
]

export default new VueRouter({
	routes: routes
	// mode:"history"
})
